@if (hasAnyFormula) {
  <div class="output-formula-picker" [attr.aria-label]="label">
    <div class="picker-header-actions">
      <button
        mat-stroked-button
        type="button"
        data-testid="picker-review-filenames-button"
        [disabled]="reviewFilenamesDisabled"
        (click)="reviewFilenamesRequested.emit()">
        Review Filenames ›
      </button>
      @if (showReviewFiles) {
        <button
          mat-stroked-button
          type="button"
          data-testid="picker-review-files-button"
          [disabled]="reviewFilesDisabled"
          (click)="reviewFilesRequested.emit()">
          Review Files ›
        </button>
      }
    </div>
    <div class="picker-table" role="table">
      <div class="picker-row header" role="row">
        <span class="col col-checkbox"></span>
        <span class="col col-name">Formula</span>
        <span class="col col-stills">Stills</span>
        <span class="col col-videos">Videos</span>
      </div>

      <div class="select-all-row" role="row">
        <span class="col col-checkbox">
          <mat-checkbox
            color="primary"
            data-testid="picker-select-all"
            [checked]="selectAllTotalCount > 0 && selectedVisibleCount === selectAllTotalCount"
            [indeterminate]="selectedVisibleCount > 0 && selectedVisibleCount < selectAllTotalCount"
            (change)="onSelectAllToggle($event.checked)">
          </mat-checkbox>
        </span>
        <span class="col select-all-label">Select all</span>
      </div>

      @for (row of rows; track row.formula.id) {
        <div
          class="picker-row"
          role="row"
          [class.disabled]="row.isDisabled"
          [attr.data-testid]="'picker-row-' + row.formula.id">
          <span class="col col-checkbox">
            <mat-checkbox
              color="primary"
              [checked]="isRowFullyPicked(row.formula)"
              [indeterminate]="isRowPartiallyPicked(row.formula)"
              [disabled]="row.isDisabled"
              [matTooltip]="row.blockerTooltip ?? ''"
              [matTooltipDisabled]="row.blockerTooltip == null"
              [attr.data-testid]="'picker-row-checkbox-' + row.formula.id"
              (change)="onRowFormulaToggle(row.formula, $event.checked)">
            </mat-checkbox>
          </span>

          <span class="col col-name">
            <span class="formula-name">{{ row.formula.name }}</span>
            <span
              class="variant-badge"
              [class.range]="row.kindBadgeClass === 'range'"
              [class.ev]="row.kindBadgeClass === 'ev'"
              data-testid="variant-badge">
              <mat-icon class="mat-icon-inline">{{ row.kindBadgeClass === 'ev' ? 'grid_on' : 'format_list_numbered' }}</mat-icon>
              {{ row.kindLabel }}
            </span>
            @if (row.isDisabled) {
              <span class="interlock-warning" data-testid="interlock-warning">
                <mat-icon class="mat-icon-inline">block</mat-icon>
                {{ row.blockerTooltip }}
              </span>
            }
          </span>

          <span class="col col-stills">
            @if (row.stillsCell == null) {
              <span class="media-cell empty">—</span>
            } @else {
              <span class="media-cell">
                <span class="media-header">
                  <mat-checkbox
                    color="primary"
                    class="media-checkbox"
                    [checked]="isMediaPicked(row.formula.id, 'stills')"
                    [disabled]="row.isDisabled"
                    [attr.data-testid]="'picker-media-checkbox-stills-' + row.formula.id"
                    (change)="onMediaToggle(row.formula.id, 'stills', $event.checked)">
                  </mat-checkbox>
                  <mat-icon class="mat-icon-inline">image</mat-icon> Stills
                </span>
                <span class="spec-line">{{ row.stillsCell.specLine }}</span>
                @if (row.stillsCell.rangeConvention != null) {
                  <span class="conv-line">
                    <mat-icon class="mat-icon-inline">short_text</mat-icon>
                    <span class="conv-name">{{ row.stillsCell.rangeConvention.name }}</span>
                    <span class="conv-preview">— {{ row.stillsCell.rangeConvention.preview }}</span>
                  </span>
                }
                @if (row.stillsCell.evConventions.length > 0) {
                  <span class="ev-conv-list">
                    @for (conv of row.stillsCell.evConventions; track $index) {
                      <span class="ev-conv-item">
                        <span class="idx">{{ $index + 1 }}.</span>
                        <span class="conv-name">{{ conv.name }}</span>
                      </span>
                    }
                  </span>
                }
              </span>
            }
          </span>

          <span class="col col-videos">
            @if (row.videosCell == null) {
              <span class="media-cell empty">—</span>
            } @else {
              <span class="media-cell">
                <span class="media-header">
                  <mat-checkbox
                    color="primary"
                    class="media-checkbox"
                    [checked]="isMediaPicked(row.formula.id, 'videos')"
                    [disabled]="row.isDisabled"
                    [attr.data-testid]="'picker-media-checkbox-videos-' + row.formula.id"
                    (change)="onMediaToggle(row.formula.id, 'videos', $event.checked)">
                  </mat-checkbox>
                  <mat-icon class="mat-icon-inline">movie</mat-icon> Videos
                </span>
                <span class="spec-line">{{ row.videosCell.specLine }}</span>
                @if (row.videosCell.rangeConvention != null) {
                  <span class="conv-line">
                    <mat-icon class="mat-icon-inline">short_text</mat-icon>
                    <span class="conv-name">{{ row.videosCell.rangeConvention.name }}</span>
                    @if (row.videosCell.sharesStillsConvention) {
                      <span class="conv-preview" data-testid="conv-preview-shared">— (same convention shared)</span>
                    } @else {
                      <span class="conv-preview">— {{ row.videosCell.rangeConvention.preview }}</span>
                    }
                  </span>
                }
                @if (row.videosCell.evConventions.length > 0) {
                  <span class="ev-conv-list">
                    @for (conv of row.videosCell.evConventions; track $index) {
                      <span class="ev-conv-item">
                        <span class="idx">{{ $index + 1 }}.</span>
                        <span class="conv-name">{{ conv.name }}</span>
                      </span>
                    }
                  </span>
                }
              </span>
            }
          </span>
        </div>
      }
    </div>
  </div>
}
